import * as ng from 'angular';
import { ComponentRegistration } from '../../../core';
import { Dto } from '../../../data';
import { IAccountRequestService } from './../';
let template = require('./pending-approval.html');

class PendingApprovalComponent extends ComponentRegistration {

    constructor() {
        super('pendingApproval', {
            controller: PendingApprovalController,
            templateUrl: template,
            controllerAs: 'vm',
            bindings: {
            }
        });
    }
}

interface IPendingApprovalController {

}

class PendingApprovalController implements IPendingApprovalController {
    private static $inject: Array<string> = ['AccountRequestService'];
    private accountRequest: Dto.IAccountRequest;
    private savedAccountRequest: Dto.IAccountRequest;
    private routeSelectedId: string;

    constructor(private AccountRequestService: IAccountRequestService) {
        console.log('PendingApprovalController loading');

    }

    public $routerOnActivate(next, previous) {
        // Get the account identified by the route parameter
        var id = next.params.id;

        if (id) {
            this.routeSelectedId = id;           
        }
    }

    private accountRequestSelected(accountRequest: Dto.IAccountRequest) {
        this.accountRequest = accountRequest;
    }
  
    private onFormSaved(accountRequest: Dto.IAccountRequest) {
        this.savedAccountRequest = accountRequest;
    }   
}

let pndngAppvlComponent = new PendingApprovalComponent();
export default pndngAppvlComponent;
export { pndngAppvlComponent as PendingApprovalComponent, IPendingApprovalController, PendingApprovalController }


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./app/components/admin/pending-approval/pending-approval.ts